import React from "react";
import { useWindowDimensions, Platform } from "react-native";
import BottomTabs from "./BottomTabs";
import SideTabs from "./SideTabs";

const ResponsiveTabs = () => {
  const { width } = useWindowDimensions();

  const isMobile = Platform.OS !== "web" || width < 768;
  
  return isMobile ? <BottomTabs /> : <SideTabs />;
};

export default ResponsiveTabs;
